import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { orderBy } from 'lodash/fp';
import CustomHeaderCell from '../../widgets/custom-cell/HeaderCell';
import { StatusCell, MessageCell } from './CustomCells';

const { Column, Cell } = Table;

const ImportedItemsResult = ({ items }) => {
  const [sortType, setSortType] = useState('desc');
  const [sortColumn, setSortColumn] = useState('counter');

  const handleSortColumn = (column, type) => {
    setSortColumn(column);
    setSortType(type);
  };

  const sortedItems = orderBy(sortColumn, sortType, items);

  return (
    <Table
      sortType={sortType}
      sortColumn={sortColumn}
      onSortColumn={handleSortColumn}
      data={sortedItems}
      autoHeight
      bordered
      wordWrap
    >
      <Column width={100} sortable>
        <CustomHeaderCell>#</CustomHeaderCell>
        <Cell dataKey="counter" />
      </Column>
      <Column width={200} resizable sortable>
        <CustomHeaderCell>Name</CustomHeaderCell>
        <Cell dataKey="name" />
      </Column>
      <Column width={120} sortable>
        <CustomHeaderCell>Status</CustomHeaderCell>
        <StatusCell dataKey="status" />
      </Column>
      <Column flexGrow={1} sortable>
        <CustomHeaderCell>Message</CustomHeaderCell>
        <MessageCell dataKey="error" />
      </Column>
    </Table>
  );
};

ImportedItemsResult.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default ImportedItemsResult;
